module.exports = __webpack_public_path__ + "img/portada.b75fa4b1.png";